import { useMemo } from 'react'
import { alpha, Box, Hidden, Tooltip, Link, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import baseTheme from '../../theme/theme'
import { makeStyles } from '@mui/styles'

const useBoxBetaStyle = makeStyles((theme) => ({
  boxBeta: {
    padding: theme.spacing(0, 0.75),
    color: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    backgroundColor: alpha(theme.palette.common.black, 0.25),
    fontSize: baseTheme.typography.pxToRem(11),
    fontWeight: baseTheme.typography.fontWeightBold,
    textTransform: 'uppercase',
  },
}))

const defaultHandleClick = () => window.location('/')

const AppLogo = ({ productName = 'de Rolf groep', productPageName = 'Homepage', onClick, showBeta }) => {
  const { boxBeta } = useBoxBetaStyle()
  const handleClick = useMemo(() => onClick || defaultHandleClick, [onClick])

  return (
    <>
      <Tooltip title={`${productName} - ${productPageName}`}>
        <Link underline="hover" onClick={handleClick} data-analytics="appLogo">
          <Typography variant="h5" component="span" noWrap>
            {productName}
          </Typography>
        </Link>
      </Tooltip>
      {showBeta && (
        <Hidden smDown>
          <Box display="inline-flex" alignItems="center" className={boxBeta} mt={-1} ml={0.75}>
            <Typography variant="inherit" component="span" color="inherit">
              beta
            </Typography>
          </Box>
        </Hidden>
      )}
    </>
  )
}

AppLogo.propTypes = {
  productName: PropTypes.string,
  productPageName: PropTypes.string,
  onClick: PropTypes.func,
  showBeta: PropTypes.bool,
}

export default AppLogo
